import React from "react";
import { Navigate } from "react-router-dom";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Display from "../Display/Display";
import AttributeComponent from "./AttributeComponent";
import { PageContainer, Content, Header } from "../Drawer/PageContainer";
import { CheckForInternalUser } from "../Helpers/miscellaneous";
import { MsalContext } from "@azure/msal-react";
import { updateNode } from "../Helpers/Nodes";
import { ATTRIBUTE_PLURAL_LABEL } from "../Helpers/Labels/AttributeLabel";
import { PageContextProvider } from "../../Context/Display/Pages/PagesContext";
import { PropStoreProvider } from "../../Context/PropStore/PropStoreContext";
import { withTranslation } from "react-i18next";

class AttributesComponents extends React.Component {

    static contextType = MsalContext

    constructor(props) {
        super(props);
        this.state = {
            showOnBoardingTooltip: false,
            selectedId: null,
            show: false,
            isInternalUser: false,
            Propertyselected: this.props.selectedTab,
            entityId: this.props.entity._id,
            loading: true,
            tabs: {
                atrtibute: true,
                displayConfig: false,
            },
            showDeleteAction: false,
            headerText: [
                {
                    headerText: `${ATTRIBUTE_PLURAL_LABEL} of `,
                },
                {
                    headerText: "Pages of",
                },
            ]
        };
        this.gridRef = React.createRef();
    }

    componentDidMount = async () => {
        let { tabs } = this.state;
        tabs.displayConfig = this.props.project.developerMode;
        let isInternalUser = CheckForInternalUser(this.props.user.email)
        this.setState({
            showOnBoardingTooltip: this.props.user.entityTooltipFlow,
            isInternalUser: isInternalUser,
            tabs: tabs,
        });
        if (this.props.tReady) {
            this.updateTranslations();
        }
    };

    componentDidUpdate = (prevProps) => {
        if (this.props.tReady && this.props.tReady !== prevProps.tReady) {
            this.updateTranslations();
        }
    }

    updateTranslations = () => {
        this.setState({
            headerText: [
                {
                    headerText: this.props.t("header.properties"),
                },
                {
                    headerText: this.props.t("header.pages"),
                },
            ]
        });
    }

    handlePropertySelect = (e) => {
        this.setState({ Propertyselected: e.selected }, () => {
            this.setState({ redirect: !this.props.isAccessedFromWorkspace });
        });
    };

    goToEntity = (e) => {
        sessionStorage.setItem("selectedEntityId", this.props.entity.sysName);
        this.setState({
            redirectToEntity: true,
        });
    };

    showAction = (action) => {
        this.setState({
            show: action,
        });
    };

    toggleOnBoardingTooltip = () => {
        updateNode("User", this.props.user._id, {
            entityTooltipFlow: "false"
        })
        this.setState({
            showOnBoardingTooltip: false
        })
        this.props.updateUser({
            entityTooltipFlow: "false"
        })
    }

    render() {
        let context = this.context;

        if (this.state.redirect) {
            let url = `/${this.props.organization.orgName}/${this.props.project.name}/Entities/${this.props.entity.sysName}/`;

            if (this.state.Propertyselected === 0) {
                url += "Attributes";
            } else if (this.state.Propertyselected === 1) {
                url += "Display";
            } else {
                url += "Visualize";
            }

            this.setState({ redirect: false });

            return <Navigate to={url} />;
        }

        if (this.state.redirectToEntity) {
            return (
                <Navigate
                    to={`/${this.props.organization.orgName}/${this.props.project.name}/Entities/${this.props.entity.sysName}`}
                />
            );
        }

        return (
            <>
                {/* {
                    this.state.showOnBoardingTooltip &&
                    <OnBoardingTooltip
                        steps={entityTooltipFlow}
                        onReset={this.toggleOnBoardingTooltip}
                    />
                } */}
                <PageContainer>
                    <div className="chngBtn1">
                        <Header
                            header={this.state.headerText[this.state.Propertyselected].headerText}
                            headerLinkClicked={this.goback}
                            headerLinkText={this.props.entity.name}
                            showAction={this.state.Propertyselected === 0}
                            actionText={this.props.t("header.buttons.add")}
                            buttonLeft={true}
                            actionTestId={"new-attribute-btn"}
                            actionClicked={() => this.gridRef.current.addNew()}
                            actionDisabled={this.state.loading}
                            action3Text={this.props.t("header.buttons.select_property_template")}
                            action3Clicked={() => this.gridRef.current.showSelectAttributeTemplate()}
                            action4Text={this.props.t("header.buttons.select_shared_property")}
                            action4Clicked={() => this.gridRef.current.showSelectSharedProperty()}
                            action3Disabled={this.state.loading}
                            action2Disabled={this.state.loading}
                            action2Text={this.props.showAIButtons && this.props.t("header.buttons.alice_ai")}
                            action2Icon={this.props.showAIButtons && "fas fa-lightbulb-on"}
                            action2Clicked={this.props.showAIButtons ? this.gridRef?.current?.toggleAliceGPTDialog : null}
                            allowBackButton={true}
                            backButtonText={this.props.t("header.buttons.back_to_objects")}
                            backButtonClicked={this.goback}
                            showHelpCenter={(this.state.isInternalUser && this.props.project.developerMode) ? true : false}
                            showDeleteAction={this.state.showDeleteAction}
                            deleteActionText={this.props.t("header.buttons.bulk_delete")}
                            deleteActionClicked={() => this.gridRef.current.toggleBulkDeleteDialog()}
                            user={this.props.user}
                            helpCenterFor={this.state.Propertyselected === 0 ? "Properties" : "Pages"}
                        ></Header>
                    </div>
                    <Content>
                        <div className="custom-tab h-100">
                            {this.props.project.developerMode && this.state.isInternalUser ?
                                <TabStrip
                                    animation={false}
                                    selected={this.state.Propertyselected}
                                    onSelect={this.handlePropertySelect}
                                    className="h-100"
                                >
                                    <TabStripTab title={this.props.t("header.tabs.attributes")}>
                                        <AttributeComponent
                                            subscription={this.props.subscription}
                                            useSuspense={false}
                                            project={this.props.project}
                                            organization={this.props.organization}
                                            isInternalUser={this.state.isInternalUser}
                                            developerMode={this.state.tabs.displayConfig}
                                            ref={this.gridRef}
                                            entityId={this.props.entity._id}
                                            entityName={this.props.entity.name}
                                            sysName={this.props.entity.sysName}
                                            showDeleteAction={(value) => this.setState({ showDeleteAction: value })}
                                            showAction={this.showAction}
                                            selectedSysName={this.props.selectedSysName}
                                            onLoadingComplete={() => this.setState({ loading: false })}
                                            isUserEntity={this.props.isUserEntity}
                                            isAccessedFromWorkspace={this.props.isAccessedFromWorkspace}
                                        />
                                    </TabStripTab>
                                    {this.state.tabs.displayConfig && (
                                        <TabStripTab title={this.props.t("header.tabs.pages")}>
                                            <PropStoreProvider value={{
                                                organisationId: this.props.organization._id,
                                                advancedMode: this.props.project.developerMode,
                                                orgName: this.props.organization.orgName,
                                                projectId: this.props.project._id,
                                                project: this.props.project,
                                                entityId: this.props.entity._id,
                                                entityName: this.props.entity.name,
                                                selectedPageName: this.props.selectedPageName,
                                                selectedComponentId: this.props.selectedComponentId,
                                                sysName: this.props.entity.sysName,
                                                accessedFromDesigner: true
                                            }}>
                                                <PageContextProvider>
                                                    <Display />
                                                </PageContextProvider>
                                            </PropStoreProvider>
                                        </TabStripTab>
                                    )}
                                </TabStrip>
                                :
                                <AttributeComponent
                                    subscription={this.props.subscription}
                                    useSuspense={false}
                                    isInternalUser={this.state.isInternalUser}
                                    ref={this.gridRef}
                                    entityId={this.props.entity._id}
                                    entityName={this.props.entity.name}
                                    sysName={this.props.entity.sysName}
                                    showAction={this.showAction}
                                    showDeleteAction={(value) => this.setState({ showDeleteAction: value })}
                                    selectedSysName={this.props.selectedSysName}
                                    onLoadingComplete={() => this.setState({ loading: false })}
                                    isUserEntity={this.props.isUserEntity}
                                    isAccessedFromWorkspace={this.props.isAccessedFromWorkspace}
                                    project={this.props.project}
                                    organization={this.props.organization}
                                    developerMode={this.state.tabs.displayConfig}
                                />
                            }
                        </div>
                    </Content>
                </PageContainer >
            </>
        );
    }

    componentWillUnmount = () => {
        sessionStorage.setItem("eid", this.props.entity._id);
    };

    goback = () => {
        if (this.props.isAccessedFromWorkspace) {
            this.props.mutators.setSelectedEntity(null);
        } else {
            this.setState({
                redirectToEntity: true,
            });
        }
    };
}

export default withTranslation("attribute/common")(AttributesComponents);
